export function deentitize(text: string) {
    return text
        .replace(/&nbsp;/g, ' ')
        .replace(/&gt;/g, '>')
        .replace(/&lt;/g, '<')
        .replace(/&quot;/g, '"')
        .replace(/&apos;/g, "'")
        .replace(/&amp;/g, '&');
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/stringDeentitize.ts